import React from "react";
import { Divider, Grid, Typography } from "@mui/material";
import "../../assets/css/Footer/FooterSmall.css";

const FooterSmall = () => {
  return (
    <>
      <div className="div">
        <Divider className="divider" />
        <Grid container className="root-footer">
          <Grid
            item
            xs={12}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Typography className="text">
              © 2023–2025 - Tutti i diritti riservati – Costituzione Srl società
              a responsabilità limitata – via del Lauro 9 Milano – Partita IVA
              10353830960 -{" "}
              <a
                className="color-link-footer"
                href="https://www.legalfarm.it/termini-e-condizioni/"
              >
                Termini e condizioni
              </a>{" "}
              -{" "}
              <a
                className="color-link-footer"
                href="https://www.legalfarm.it/informativa-privacy/"
              >
                Privacy
              </a>{" "}
              -{" "}
              <a
                className="color-link-footer"
                href="https://www.legalfarm.it/cookie"
              >
                Cookie
              </a>
            </Typography>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default FooterSmall;
